import React from 'react';
import PropTypes from 'prop-types';
import {gql} from 'apollo-boost';
import {Query} from 'react-apollo';
import {fieldObjectSectionStyle} from "../../helpers/graphQLShortcuts";
import {fieldObjectSectionStyleCss} from "../../helpers/createStyles";
import InlineDealerPage from "./InlineDealerPage";

interface Data {
    paragraphById: {
        fieldTxtHeadline: string;
        fieldVarGroupToInclude: string;
        fieldRefRankingsPage: Array<{
            targetId: string;
        }>;
        fieldDealersSectionStyle: Array<{
            targetId: string;
        }>;
    }
}

class InlineDealersQuery extends Query<Data, {id: string}> {}

const GET_COMPONENT = gql`
    query paragraphByRevisionId($id: String!) {
        paragraphById:paragraphRevisionById(id: $id) {
            ... on Paragraph {
                ... on Paragraph {
                    ... on ParagraphComponentInlineDealer {
                        fieldTxtHeadline
                        fieldVarGroupToInclude
                        fieldRefRankingsPage {
                            targetId
                        }
                        fieldDealersSectionStyle {
                                ${fieldObjectSectionStyle}
                        }
                    }
                }
            }
        }
    }
`;

const InlineDealers = ({id, markComponentLoadedAs}) => (
    <InlineDealersQuery asyncMode query={GET_COMPONENT} variables={{ id }}>
        {({ loading, error, data }) => {
            if (loading) return null;
            if (error || !data.paragraphById) {
                markComponentLoadedAs(id, true);
                return <div>{error || null}</div>;
            }

            const field = data.paragraphById;
            const styles = fieldObjectSectionStyleCss(field.fieldDealersSectionStyle);

            markComponentLoadedAs(id, true);

            return (
                <div style={styles.css}>
                    {styles.childBackground.isActive && (
                        <div style={styles.childBackground.css}/>
                    )}
                    {field.fieldRefRankingsPage.targetId && (
                        <InlineDealerPage headline={field.fieldVarGroupToInclude && field.fieldTxtHeadline ? field.fieldTxtHeadline : ''}
                                          pageID={field.fieldRefRankingsPage.targetId}
                                          group={field.fieldVarGroupToInclude || ''}/>
                    )}
                </div>
            );
        }}
    </InlineDealersQuery>
);

InlineDealers.propTypes = {
    id: PropTypes.number.isRequired,
    markComponentLoadedAs: PropTypes.func.isRequired,
    // eslint-disable-next-line react/no-unused-prop-types
    handleLoadedComponents: PropTypes.func.isRequired
};

export default InlineDealers;



// WEBPACK FOOTER //
// ./frontend/components/InlineDealer/InlineDealers.jsx